import { Server } from "mock-socket";

const MOCK_SOCKET_URL = "ws://localhost:9876";
export const USE_MOCK_SOCKET = false;
let mockSocket: Server;

export function useMockSocketServer() {
  if (!USE_MOCK_SOCKET) {
    return {
      sendMessageToClient: (_a: string, _b: any) => {
        console.log(_a, _b);
      },
      mockSocketUrl: MOCK_SOCKET_URL,
    };
  }
  if (!mockSocket) mockSocket = new Server(MOCK_SOCKET_URL);

  mockSocket.on("connection", socket => {
    socket.send("pong");
    console.log("Connected to mock socket");
    socket.on("message", message => {
      if (message === "ping") {
        socket.send("pong");
      }
    });
  });

  mockSocket.on("disconnect", () => {
    console.log("Disconnected from mock socket");
  });
  function sendMessageToClient(action: string, data: any) {
    mockSocket.clients().forEach(client => {
      client.send(JSON.stringify({ action, data }));
    });
  }
  return { sendMessageToClient, mockSocketUrl: MOCK_SOCKET_URL };
}
